import React from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import OpenInNew from "@mui/icons-material/OpenInNew";
import { ExternalLink } from "../styleguide/AppLink";
import { TTGDA_LICENSING_SCORING_RUBRIC_URL } from "./ttgda-links";

/**
 * @param {object} props
 * @param {import("react").ReactNode} props.children
 */
const RubricLink = ({ children }) => (
  <ExternalLink href={TTGDA_LICENSING_SCORING_RUBRIC_URL}>
    {children}
    <OpenInNew fontSize="inherit" sx={{ ml: 0.5, verticalAlign: "text-bottom" }} />
  </ExternalLink>
);

/**
 * Promo alert for contracts list screens.
 */
export const TtgdaRubricPromoAlert = () => (
  <Box paddingBottom={1} paddingLeft={1} paddingRight={1}>
    <Alert severity="info">
      Negotiating a contract? <RubricLink>Check the TTGDA scoring rubric</RubricLink>
    </Alert>
  </Box>
);

/**
 * Info box shown under pitch status when negotiating a contract.
 *
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PublisherGameStatus} props.status
 */
export const TtgdaContractNegotiationInfoBox = ({ status }) => {
  if (status !== "InContractNegotiation") {
    return null;
  }

  return (
    <Box paddingBottom={1}>
      <Alert severity="info">
        Negotiating a contract? <RubricLink>Check the TTGDA scoring rubric</RubricLink>
      </Alert>
    </Box>
  );
};
